import React from 'react';
import { Box } from '@chakra-ui/react';

const GRAIN_BG = `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E")`;

export default function FilmGrain({ opacity = 0.045 }) {
	return (
		<Box
			position='absolute'
			inset={0}
			pointerEvents='none'
			opacity={opacity}
			zIndex={2}
			style={{
				backgroundImage: GRAIN_BG,
				backgroundRepeat: 'repeat',
				backgroundSize: '128px 128px',
				mixBlendMode: 'overlay',
			}}
		/>
	);
}
